import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE__utils_index_js_57e9e83f__ from "../../utils/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__variants_interactions_iconButtonVariants_utils_js_8ef17c7e__ from "../../variants/interactions/iconButtonVariants.utils.js";
import * as __WEBPACK_EXTERNAL_MODULE__CdnIcon_index_js_9849600d__ from "../CdnIcon/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__IconButton_variants_js_c9446210__ from "./IconButton.variants.js";
const IconButton_IconButton = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ onClick, fillNone = false, className, iconName, buttonClassName, ...props }, ref) {
    const { buttonSlot, wrapperSlot, iconSlot, tapSpaceSlot } = (0, __WEBPACK_EXTERNAL_MODULE__IconButton_variants_js_c9446210__.iconButtonVariants)({
        ...props,
        fillNone
    });
    const classes = (0, __WEBPACK_EXTERNAL_MODULE__utils_index_js_57e9e83f__.cn)(className, wrapperSlot());
    const iconSize = (0, __WEBPACK_EXTERNAL_MODULE__variants_interactions_iconButtonVariants_utils_js_8ef17c7e__.getIconSize)(props.size);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("button", {
        type: "button",
        onClick: onClick,
        ...(0, __WEBPACK_EXTERNAL_MODULE__utils_index_js_57e9e83f__.cleanProps)(props, [
            'type',
            'shadow',
            'active'
        ]),
        className: (0, __WEBPACK_EXTERNAL_MODULE__utils_index_js_57e9e83f__.cn)(buttonSlot(), buttonClassName),
        ref: ref,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                className: tapSpaceSlot()
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                className: classes,
                "data-testid": "icon-button-wrapper",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__CdnIcon_index_js_9849600d__.CdnIcon, {
                    className: iconSlot(),
                    iconName: iconName,
                    size: iconSize
                })
            })
        ]
    });
});
export { IconButton_IconButton as IconButton };
